import CircularProgress from '@mui/material/CircularProgress';
import { postChangePWE } from 'api/calls';
import axios from 'axios';
import { Button } from 'components/atoms';
import { AuthModel } from 'components/types';
import { ChangePasswordReq } from 'components/types/Api';
import { ModalType } from 'components/types/types';
import { useFormik } from 'formik'
import React, { useContext, useState } from 'react'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import { useAuth } from 'shared/auth';
import * as Yup from "yup";
import YupPassword from 'yup-password'
import { AUTH_LOCAL_STORAGE_KEY } from 'shared/auth/authHelpers';


YupPassword(Yup)
const ChangePassword = () => {
    const {
        setchangePWisOpen,
        getUserData,
        loginType,
        setModal,
        setErrorModal,
        setClosedModal
    } = useContext(AppGeneralContext)
    const { saveAuth } = useAuth()
    const [isSubmitting, setSubmitting] = useState<boolean>(false)

    const changePWSchema = Yup.object().shape({
        oldPassword: Yup.string().password()
            .required('Please complete this required field.')
            .min(8, 'Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special')
            .minLowercase(1, 'Password must contain at least 1 lower case letter')
            .minUppercase(1, 'Password must contain at least 1 upper case letter')
            .minNumbers(1, 'Password must contain at least 1 number')
            .minSymbols(1, 'Password must contain at least 1 special character'),
        newPassword: Yup.string().password()
            .required('Please complete this required field.')
            .min(8, 'Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special')
            .minLowercase(1, 'Password must contain at least 1 lower case letter')
            .minUppercase(1, 'Password must contain at least 1 upper case letter')
            .minNumbers(1, 'Password must contain at least 1 number')
            .minSymbols(1, 'Password must contain at least 1 special character'),
        confirmPassword: Yup.string().when("newPassword", {
            is: (newPassword: string) => newPassword && newPassword.length > 0,
            then: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], 'Passwords doesen\'t match')
                .required('Please complete this required field.'),
        }),
    });

    const formikChangePW = useFormik<ChangePasswordReq>({
        initialValues: { "oldPassword": "", "confirmPassword": "", "newPassword": "" },
        validationSchema: changePWSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setSubmitting(true)

            postChangePWE(values).then(async (res) => {
                formikChangePW.setFieldValue("oldPassword", "")
                formikChangePW.setFieldValue("newPassword", "")
                formikChangePW.setFieldValue("confirmPassword", "")
                setchangePWisOpen(false)
                setSubmitting(false)

                if (!res.isSuccess || !res.response) {
                    setErrorModal(res.error)
                    setSubmitting(false)
                    return
                }
                const localStorageValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
                if (localStorageValue) {
                    const auth: AuthModel = JSON.parse(localStorageValue) as AuthModel
                    const authUpdated = { ...auth, jwtToken: res.response?.jwtToken }
                    saveAuth(authUpdated)
                }

                axios.defaults.headers.common['Authorization'] = "Bearer " + res.response?.jwtToken;

                if (loginType) {
                    const reloaded = await getUserData(loginType)
                    if (reloaded) {
                        setClosedModal()
                    }
                }

                setModal({ isOpen: true, type: ModalType.info, title: "Change password", message: "Your passwords has been changed." })

            })
        }
    })

    return (
        <div className=''>
            <div className="d-flex align-items-center">
                <h1 className='text-center'>Change password</h1>
            </div>
            <div className="tx-white">
                <form onSubmit={formikChangePW.handleSubmit} className='mb-5' autoComplete='off' id='changePW'>

                    <div className='col-xs-12 flex-grow-1'>
                        <label className='text-black mt-3' htmlFor="password">Old password</label>
                        <input
                            autoComplete="new-password"
                            placeholder='Old password'
                            {...formikChangePW.getFieldProps('oldPassword')}
                            className="form-input"
                            type="password"
                            onChange={formikChangePW.handleChange}
                            onBlur={() => formikChangePW.setFieldTouched("oldPassword", true)}
                            value={formikChangePW.values.oldPassword}
                            name="oldPassword"
                        />
                        {formikChangePW.errors.oldPassword && formikChangePW.touched.oldPassword && <div className='text-error' id="oldPassword">{formikChangePW.errors.oldPassword}</div>}
                    </div>

                    <div className='col-xs-12 flex-grow-1'>
                        <label className='text-black mt-3' htmlFor="password">New password</label>
                        <input
                            autoComplete="new-password"
                            placeholder='New password'
                            {...formikChangePW.getFieldProps('newPassword')}
                            className="form-input"
                            type="password"
                            onChange={formikChangePW.handleChange}
                            onBlur={() => formikChangePW.setFieldTouched("newPassword", true)}
                            value={formikChangePW.values.newPassword}
                            name="newPassword"
                        />
                        {formikChangePW.errors.newPassword && formikChangePW.touched.newPassword && <div className='text-error' id="newPassword">{formikChangePW.errors.newPassword}</div>}
                    </div>

                    <div className='col-xs-12 flex-grow-1'>
                        <label className='text-black mt-3' htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            autoComplete="new-password"
                            placeholder='Confirm password'
                            {...formikChangePW.getFieldProps('confirmPassword')}
                            className="form-input"
                            type="password"
                            onChange={formikChangePW.handleChange}
                            onBlur={() => formikChangePW.setFieldTouched("confirmPassword", true)}
                            value={formikChangePW.values.confirmPassword}
                            name="confirmPassword"
                        />
                        {formikChangePW.errors.confirmPassword && formikChangePW.touched.confirmPassword && <div className='text-error' id="confirmPassword">{formikChangePW.errors.confirmPassword}</div>}
                    </div>

                    <div className='d-flex justify-content-end mt-4'>
                        <Button
                            disabled={isSubmitting}
                            icon={isSubmitting ? <CircularProgress style={{ height: "20px", width: "20px", marginRight: "10px" }} color="inherit" /> : <></>}
                            type="submit"
                            className='mt-1'
                            color='var(--white)'
                            background='var(--primary)'
                            borderColor='var(--primary)'
                            fontWeight={'800'}
                            uppercase primary text='save' />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ChangePassword